import { appInfo } from "@/common/data/appinfo.js";
import grades25 from "./twf/grades.js";
import payments26 from "./tws/payments.js";
import centers26 from "./tws/centers.js";
export default [
  {
    path: "/FVBliy",
    children: [
      ...grades25,
      ...payments26,
      ...centers26,
      //GAZzete

      // {
      //   path: "/ToGJ1QZwez",
      //   children: [
      //     {
      //       path: "/BbD6e3",
      //       name: "qe25.gazettes",
      //       component: () => import("@/views/qe/twf/gazette/list.vue"),
      //       meta: {
      //         title:
      //           appInfo?.type == "codemsi"
      //             ? "SAISSCE 2025 Gazettes"
      //             : "QE 2025 Gazettes",
      //         authRequired: true,
      //         acc: ["y68184"],
      //       },
      //     },
      //     {
      //       path: "/KBKzTOAs",
      //       name: "qe25.pendinggazettereq",
      //       component: () =>
      //         import("@/views/qe/twf/gazette/pendingrequests.vue"),
      //       meta: {
      //         title:
      //           appInfo?.type == "codemsi"
      //             ? "SAISSCE 2025 Pending Gazette Requests"
      //             : "QE 2025 Pending Gazette Requests",
      //         authRequired: true,
      //         acc: ["y76563"],
      //       },
      //     },
      //     {
      //       path: "/zb9ukZ",
      //       name: "qe25.uploadgazette",
      //       component: () => import("@/views/qe/twf/gazette/upload.vue"),
      //       meta: {
      //         title:
      //           appInfo?.type == "codemsi"
      //             ? "Upload SAISSCE 2025 Gazette"
      //             : "Upload QE 2025 Gazette",
      //         authRequired: true,
      //       },
      //     },
      //     {
      //       path: "/D1S6xfB2gp",
      //       name: "qe25.uploadedgazettes",
      //       component: () =>
      //         import("@/views/qe/twf/gazette/uploaded-gazette.vue"),
      //       meta: {
      //         title:
      //           appInfo?.type == "codemsi"
      //             ? "Uploaded SAISSCE 2025 Gazettes"
      //             : "Uploaded QE 2025 Gazettes",
      //         authRequired: true,
      //         acc: ["y10535"],
      //       },
      //     },
      //     {
      //       path: "/LzHfz3tVv/:er?",
      //       name: "qe25.gazette",
      //       component: () => import("@/views/qe/twf/gazette/vgazette.vue"),
      //       meta: {
      //         title:
      //           appInfo?.type == "codemsi"
      //             ? "Print SAISSCE Gazette"
      //             : "Print QE Gazette",
      //         authRequired: true,
      //         acc: ["y63307"],
      //       },
      //     },
      //   ],
      // },

      //Students
      {
        path: "/vXkeGOh",
        children: [
          {
            path: "/Gm5XwwU90P",
            name: "qe25.students",
            meta: {
              title:
                appInfo?.type == "codemsi"
                  ? "SAISSCE 2025 students"
                  : "QE 2025 students",
              authRequired: true,
              acc: ["y12856"],
            },
            component: () => import("@/views/qe/twf/student/index.vue"),
          },
          {
            path: "/pgjqmlM/:str?",
            name: "qe25.student",
            meta: {
              title:
                appInfo?.type == "codemsi"
                  ? "View SAISSCE 2025 student"
                  : "View QE 2025 student",
              authRequired: true,
              acc: ["y11371"],
            },
            component: () => import("@/views/qe/twf/student/view.vue"),
          },
          {
            path: "/WWPel8X/:str?",
            name: "qe25.studentedit",
            meta: {
              title:
                appInfo?.type == "codemsi"
                  ? "Edit SAISSCE 2025 student"
                  : "Edit QE 2025 student",
              authRequired: true,
              acc: ["y59433"],
            },
            component: () => import("@/views/qe/twf/student/edit.vue"),
          },
          {
            path: "/tDCcdx",
            name: "qe25.addstudent",
            meta: {
              title:
                appInfo?.type == "codemsi"
                  ? "ADD SAISSCE 2025 student"
                  : "ADD QE 2025 student",
              authRequired: true,
              acc: ["y64839"],
            },
            component: () => import("@/views/qe/twf/student/add.vue"),
          },
        ],
      },
    ],
  },
];
